import { Button, Checkbox, Flex, Text, Image } from "@chakra-ui/react";
import React from "react";
import { DeleteSelectedButton } from "@components/chat-delete-menu/DeleteSelectedButton"; // Import the DeleteSelectedButton
import CheckMark from "@assets/images/checkmarkIcon.svg";
import { useTranslation } from "react-i18next";

interface ChatSelectionActionsProps {
  threads: any;
  selectedChats: Record<string, boolean>;
  handleSelectAllChange: (isChecked: boolean) => void;
  handleCancelSelection: () => void;
  handleRemoveAllChats: () => void;
}

const ChatSelectionActions: React.FC<ChatSelectionActionsProps> = ({
  threads,
  selectedChats = {},
  handleSelectAllChange = () => {},
  handleCancelSelection = () => {},
  handleRemoveAllChats = () => {},
}) => {
  const { t } = useTranslation("common");

  const dynamicSelectedCount =
    Object.values(selectedChats).filter(Boolean).length;

  const [checkedItems, setCheckedItems] = React.useState<boolean[]>([]);

  const handleChildCheckbox =
    (index: number) => (e: React.ChangeEvent<HTMLInputElement>) => {
      const newCheckedItems = [...checkedItems];
      newCheckedItems[index] = e.target.checked;
      setCheckedItems(newCheckedItems);
      handleSelectAllChange(newCheckedItems.every(Boolean));
    };

  return (
    <Flex alignItems="center" justifyContent="space-between">
      {threads && threads.length > 0 && (
        <Flex direction="column" gap="2">
          <Checkbox
            isChecked={checkedItems[0]}
            onChange={handleChildCheckbox(0)}
            sx={{
              borderColor: "#C5C7D0",
            }}
          >
            {t("chat.selectAll")}
          </Checkbox>
        </Flex>
      )}
      {/* Action Buttons */}
      <Flex
        ml="auto"
        gap="8px"
        visibility={dynamicSelectedCount > 0 ? "visible" : "hidden"}
      >
        {/* Selected Chats Count */}
        <Flex gap="5px" alignItems="center">
          <Image src={CheckMark} height="14px" width="14px" />

          <Text textColor={"purple.500"}>
            {dynamicSelectedCount > 0
              ? `${dynamicSelectedCount} ${t("chat.selectedChat")}${
                  dynamicSelectedCount > 1 ? "s" : ""
                }`
              : null}
          </Text>
        </Flex>

        {/* Cancel Selection Button */}
        <Button
          width="61px"
          height="32px"
          border="1px solid #C5C7D0"
          backgroundColor="transparent"
          textColor="black"
          onClick={handleCancelSelection}
          size="sm"
          colorScheme="gray"
        >
          {t("translate.cancel")}
        </Button>

        {/* Delete Selected Chats Button */}
        <DeleteSelectedButton
          onRemoveClick={handleRemoveAllChats}
          selectedChatCount={dynamicSelectedCount}
          isDisabled={dynamicSelectedCount === 0}
        />
      </Flex>
    </Flex>
  );
};

export default ChatSelectionActions;
